/* Heavenly Crafted conversion layer — 2026-08-28 */
(function(){
  'use strict';
  var pathMap={
    '/collections/gospel-noir-shopify-mugs':'/collections/mugs',
    '/collections/gospel-noir-shopify-mugs-clothing':'/collections/clothing',
    '/collections/gospel-noir-shopify-puzzles':'/collections/puzzles',
    '/collections/frontpage':'/collections/gospel-noir',
    '/pages/gospel-noir-shopify-about-gospel-noir':'/pages/about-gospel-noir',
    '/pages/about':'/pages/about-gospel-noir'
  };
  function fixLinks(){
    document.querySelectorAll('a[href]').forEach(function(a){
      var raw=a.getAttribute('href')||'';
      if(pathMap[raw]) a.setAttribute('href',pathMap[raw]);
      if(raw.indexOf('heavenlycraftedstore.myshopify.com/products/journal')!==-1) a.setAttribute('href','/collections/journals');
    });
  }
  function fixClaims(){
    document.querySelectorAll('.gn-ship-bar').forEach(function(el){
      el.textContent='✦ Secure Checkout  |  Tracking After Shipment  |  30-Day Return Window ✦';
    });
    var seenSSL=false;
    document.querySelectorAll('footer span').forEach(function(el){
      var t=(el.textContent||'').trim();
      if(t.indexOf('SSL Secured Checkout')!==-1){ if(seenSSL){el.remove();return;} seenSSL=true; }
      if(t.indexOf('Fulfilled via Printful')!==-1) el.textContent='✦ Made to Order';
      if(t.indexOf('US Shipping')!==-1) el.textContent='✦ Shipping Shown at Checkout';
    });
  }
  function improveCards(){
    document.querySelectorAll('.pol-cta,.pol-add').forEach(function(a){
      a.textContent='Shop This Item';
      a.setAttribute('aria-label','Shop this item');
    });
  }
  function addTrustStrip(){
    if(document.querySelector('.hc-cro-strip')) return;
    var nav=document.querySelector('nav');
    if(!nav) return;
    var strip=document.createElement('div');
    strip.className='hc-cro-strip';
    strip.innerHTML='<span><strong>10% off your first order</strong> when you join</span><span>Secure checkout</span><span>Shop Pay · Apple Pay · Google Pay</span><a href="/collections/christian-gifts-under-30">Shop gifts under $30</a>';
    nav.insertAdjacentElement('afterend',strip);
  }
  function productCRO(){
    var atc=document.getElementById('gnp-atc');
    var actions=document.getElementById('gnp-primary-actions');
    if(actions && !document.querySelector('.gnp-cro-note')){
      var note=document.createElement('div');
      note.className='gnp-cro-note';
      note.innerHTML='<span>Secure checkout</span><span>Tracking after shipment</span><span>30-day return window</span>';
      actions.appendChild(note);
    }
    var form=document.getElementById('gn-product-form');
    if(form && atc){
      form.addEventListener('submit',function(){
        if(atc.disabled) return;
        var original=atc.textContent;
        atc.classList.add('is-loading');
        atc.textContent='Adding to Cart…';
        window.setTimeout(function(){atc.classList.remove('is-loading');if(document.body.contains(atc))atc.textContent=original;},2800);
      });
    }
  }
  function init(){fixLinks();fixClaims();improveCards();productCRO();} /* addTrustStrip retired: it injected a 3rd bar into the fixed header and hard-coded wallet names */
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
